import { useLocation } from "react-router-dom";
import { AppBar, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

import useWidth from "hooks/useWidth";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: 244,
    backgroundColor: theme.palette.background.paper,
    padding: "40px 52px 40px 0",
    [theme.breakpoints.down("lg")]: {
      width: 244,
      padding: "25px 48px 25px 0",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: 48,
    },
  },
  catalogMobile: {
    width: `calc(100% + ${theme.spacing(8)})`,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(0, 2),
    margin: theme.spacing(0, -4),
    boxShadow: "none",
  },
  catalogDetailMobile: {
    boxShadow: "none",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0, 2),
  },
  genericMobile: {
    width: `calc(100% + ${theme.spacing(8)})`,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0, 2),
    margin: theme.spacing(0, -4),
    boxShadow: "none",
  },
}));

const LeftContent = ({
  children,
  className,
}: React.HTMLAttributes<HTMLElement>) => {
  const classes = useStyles();
  const width = useWidth();

  const location = useLocation();
  const { pathname } = location;

  const appBarClass =
    pathname === "/catalog"
      ? classes.catalogMobile
      : pathname.includes("/detail")
      ? classes.catalogDetailMobile
      : classes.genericMobile;
  if (["xs", "sm"].includes(width)) {
    return (
      <AppBar
        component="section"
        position="relative"
        color="transparent"
        className={appBarClass}
      >
        {children}
      </AppBar>
    );
  }

  return (
    <div className={`${classes.container} ${className || ""}`}>{children}</div>
  );
};

export default LeftContent;
